import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import { EuiSpacer } from "@elastic/eui";
import SuccessBox from 'components/Web_User_Interface/1440p_Series/System/My_Account/SuccessBox';
import PermissionBox from 'components/Web_User_Interface/1440p_Series/_permissions/SystemChangeUserDataPerm';
import AccountTable from 'components/Web_User_Interface/1440p_Series/System/My_Account/AccountTable';
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
export const _frontmatter = {
  "title": "System Menu // Mein Account",
  "path": "/Web_User_Interface/1440p_Serie/System/My_Account/",
  "dateChanged": "2023-01-18",
  "author": "Mike Polinowski",
  "excerpt": "Web User Interface Settings",
  "image": "./WebUI_1440p_SearchThumb_System_WebUI.png",
  "social": "/images/Search/WebUI_1440p_SearchThumb_System_WebUI.webp",
  "toc": "/images/Search/TOC_Icons/Wiki_Tiles_WebUI_white.webp",
  "chapter": "1440p Web User Interface"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <SEOHelmet title='System Menu // Mein Account' dateChanged='2023-01-18' author='Mike Polinowski' tag='INSTAR IP Camera' description='Web User Interface Settings' image='/images/Search/WebUI_1440p_SearchThumb_System_WebUI.png' twitter='/images/Search/WebUI_1440p_SearchThumb_System_WebUI.webp' location={props.location.pathname} mdxType="SEOHelmet" />
    <BreadCrumbs locationBC={props.location} locationDE={props.location.pathname} locationEN='/en/Web_User_Interface/1440p_Series/System/My_Account/' locationFR='/fr/Web_User_Interface/1440p_Series/System/My_Account/' crumbLabel="Account" mdxType="BreadCrumbs" />
    <h1 {...{
      "id": "ultrahd-serien-2k-1440p--4k-2160p",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h1" {...{
        "href": "#ultrahd-serien-2k-1440p--4k-2160p",
        "aria-label": "ultrahd serien 2k 1440p  4k 2160p permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`UltraHD Serien (2K+ 1440p & 4K 2160p)`}</h1>
    <h2 {...{
      "id": "system-menü",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#system-men%C3%BC",
        "aria-label": "system menü permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`System Menü`}</h2>
    <EuiSpacer mdxType="EuiSpacer" />
    <SuccessBox mdxType="SuccessBox" />
    <EuiSpacer mdxType="EuiSpacer" />
    <PermissionBox mdxType="PermissionBox" />
    <EuiSpacer mdxType="EuiSpacer" />
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "920px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/de/static/2fa867b14de9d0edd44c0785ca31c72c/e4a12/1440p_Settings_System_My_Account.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "49.565217391304344%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAYAAAC0VX7mAAAACXBIWXMAAA7rAAAO6wFxzYGVAAACNklEQVQoz22Ry2oTYRxH8xgWQSiluU6StrmYZiYzk0kmpLlO5pKZCYpaa9Ci1t670KJUEdy5kUp109ruFAQfwG6sG5/pyMS2QXRx+H2rw+H7h1KpFIKQJBaeIl+1MHa/srB5Qm39BG31mMrqMcrjI+RHhyjnBO/a6iHWsy80+3e5dvUKExMTTE5OEkokEiQSApHpKQpam5u7R3g7B7jbH7A3D3C2Drj94ojFl59Y3Btz//Uxw1cnaA0HIR5HENIkk2lC8XicgGg0RjYzS99s4/Ra9Np1uo0attHg2+c3nJ3u8/P0/Ygf3/f5dfaRd2+3kYoKilylrOqIonJRmCAajZLL5fH9Aa7n03c9eqaFaVmsrCyxvj5kbe3eJRsbQ4bDW9SqdcqqhiJrFOdLY2EkEiGbzeJ5Hv1+H8uyME2TbrdLoSAyM5MZM5shnZ5DUTUcq45eUZFLlX+FuVwOz/dxHIder4dhGCOprldRVQVJkpAkcYQoFtF1nRt+jVpVQS5pSOJ/CgeDAb7vj0pd1x1tp9Om2WrRaLZoNJo06nV6hoHveTjdChVVQdfKlCSJUCwW+0t4IQs2kAe1QaVptDE7C5hGi67rYgx8nMGAZbeDXpZHQrEoEQqOIQjC6Cj5fP7y/2zbPsfBti2cxSf0H+7hLm2x0zF43umx3DV5esfBbmjIciAs/SlMJpMEm06nUVUVWZYRRXFMcR6xdYuSv43cHfJgLsdG5jperkB2LkUqHmY6HCEcjvAbxIx9GL5xAygAAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/2fa867b14de9d0edd44c0785ca31c72c/e4706/1440p_Settings_System_My_Account.avif 230w", "/de/static/2fa867b14de9d0edd44c0785ca31c72c/d1af7/1440p_Settings_System_My_Account.avif 460w", "/de/static/2fa867b14de9d0edd44c0785ca31c72c/7f308/1440p_Settings_System_My_Account.avif 920w", "/de/static/2fa867b14de9d0edd44c0785ca31c72c/43a10/1440p_Settings_System_My_Account.avif 963w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/avif"
            }}></source><source parentName="picture" {...{
              "srcSet": ["/de/static/2fa867b14de9d0edd44c0785ca31c72c/a0b58/1440p_Settings_System_My_Account.webp 230w", "/de/static/2fa867b14de9d0edd44c0785ca31c72c/bc10c/1440p_Settings_System_My_Account.webp 460w", "/de/static/2fa867b14de9d0edd44c0785ca31c72c/966d8/1440p_Settings_System_My_Account.webp 920w", "/de/static/2fa867b14de9d0edd44c0785ca31c72c/095e2/1440p_Settings_System_My_Account.webp 963w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/2fa867b14de9d0edd44c0785ca31c72c/81c8e/1440p_Settings_System_My_Account.png 230w", "/de/static/2fa867b14de9d0edd44c0785ca31c72c/08a84/1440p_Settings_System_My_Account.png 460w", "/de/static/2fa867b14de9d0edd44c0785ca31c72c/c0255/1440p_Settings_System_My_Account.png 920w", "/de/static/2fa867b14de9d0edd44c0785ca31c72c/e4a12/1440p_Settings_System_My_Account.png 963w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/de/static/2fa867b14de9d0edd44c0785ca31c72c/c0255/1440p_Settings_System_My_Account.png",
              "alt": "Web User Interface - 1440p Serie - System - Mein Account",
              "title": "Web User Interface - 1440p Serie - System - Mein Account",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <EuiSpacer mdxType="EuiSpacer" />
    <AccountTable mdxType="AccountTable" />
    <EuiSpacer mdxType="EuiSpacer" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      